module.exports = __webpack_public_path__ + "assets/img/be7a8af001267e09483a5025233ac0ab.png";